import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NgIf } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';

@Component({
  selector: 'app-campaign-banner',
  templateUrl: './campaign-banner.component.html',
  styleUrls: ['./campaign-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselModule, NgIf],
  standalone: true,
})
export class CampaignBannerComponent implements OnInit, OnDestroy {
  private readonly bannerService = inject(BannerService);
  private readonly destroy$ = new Subject<void>();
  private isMobile = signal(window.innerWidth < 768);
  showCampaignBanner: boolean = environment.showCampaignBanner;
  slides = signal<Array<{ src: string; alt: string; href: string }>>([]);
  items = signal<any>(['hello 1', ' hello 2']);
  ngOnInit() {
    if (!this.showCampaignBanner) {
      return;
    }
    this.loadSlides();
    window.addEventListener('resize', this.handleResize);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener('resize', this.handleResize);
  }

  private handleResize = () => {
    const wasMobile = this.isMobile();
    this.isMobile.set(window.innerWidth < 768);
    if (wasMobile !== this.isMobile()) {
      this.loadSlides();
    }
  };

  private loadSlides() {
    this.bannerService
      .getBanners()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        const isMobile = this.isMobile();
        const slides = response.results
          .filter((b) => b.is_active)
          .map((b) => ({
            src: isMobile ? b.mobile_banner_url : b.banner_url,
            alt: b.title,
            href: b.link,
          }));
        console.log(slides);

        this.slides.set(slides);
      });
  }

  onSlideClick(slide: { href: string }) {
    if (slide.href) {
      window.open(slide.href, '_blank');
    }
  }
}
